import { useRoute } from 'vue-router'
import type { RouteLocationRaw } from 'vue-router'

import { Routes } from '@/const/Routes'
import RouteParam from '@/enums/RouteParam'
import { createSlug } from '@/utils'
import type { Route } from '@/types/Route'
import type { IbexaBaseItemFields } from '@/types/Ibexa'
import { router } from '@/router'
import { getParentPath } from '@/utils/getParentPath'

export const useAppRouting = () => {
  const { params, path, query } = useRoute()

  const getContentIdFromRouteParam = (routeParam: RouteParam): number => {
    const slug = params[routeParam] as string
    if (!slug) return -1
    const contentId = slug.split('_id:').slice(-1)[0]

    const numberRegex = /^[0-9]+$/

    if (numberRegex.test(contentId)) {
      return parseInt(contentId)
    } else {
      router.push('/404')
      return -1
    }
  }

  const getRouteWithParams = (route: Route, element?: IbexaBaseItemFields) => {
    return {
      name: route.name,
      params: {
        ...params,
        ...(element && { [route.param as string]: createSlug(element) }),
      }
    }
  }

  const getParentRoute = (): RouteLocationRaw => {
    if (path === Routes.Home.path) return { name: Routes.Home.name }

    return { path: getParentPath(path), query: query }
  }

  return {
    getContentIdFromRouteParam,
    getRouteWithParams,
    getParentRoute,
  }
}